module.exports = __webpack_public_path__ + "img/hotel.50e367c6.svg";